import { Observable, of, tap } from "rxjs";
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";
import { DictionaryModel } from "../models/dictionary.model";

@Injectable()
export class DictionaryService {
  private firmDictionaryWordCount: number = 0;
  private firmNameAndStaffForCaseDictionary: DictionaryModel;

  constructor(private api: ApiService) {
    this.firmNameAndStaffForCaseDictionary = {
      words: [],
    };
  }

  getTXdocsDictionary(): Observable<DictionaryModel> {
    return this.api.get<DictionaryModel>('dictionary/get');
  }

  getFirmNameAndStaffForCaseDictionary(): Observable<DictionaryModel> {
    if (this.firmNameAndStaffForCaseDictionary?.words && this.firmNameAndStaffForCaseDictionary.words.length > 0) {
      return of(this.firmNameAndStaffForCaseDictionary);
    } else {
      return this.api.get<DictionaryModel>('dictionary/getfirmnameandstaffforcasedictionary').pipe(
        tap((res: DictionaryModel) => {
          this.firmNameAndStaffForCaseDictionary = res;
        })
      );
    }
  }

  getFirmDictionary(): Observable<DictionaryModel> {
    return this.api.get<DictionaryModel>('dictionary/getfirmdictionary');
  }

  saveFirmDictionary(words: string[]) {
    return this.api.post<string[]>('dictionary/savefirmdictionary', { words: words });
  }

  getFirmDictionaryWordCount(): number {
    return this.firmDictionaryWordCount;
  }

  setFirmDictionaryWordCount(count: number) {
    this.firmDictionaryWordCount = count;
  }

  getUniqueWordsForCaseDictionary(words: string[]) {
    if (words.length == 0) {
        return [];
    }

    const allWords = words
      .join(' ')
      .replace(/[^\w\s]/g, ' ')
      .split(' ');
    const uniqueWords = [...new Set(allWords)];

    return uniqueWords;
  }
}